import {
  InteractiveClassCreate,
  InteractiveClassesList
} from 'pages/teaching_resources/interactive_classes';
import { InteractiveClassEdit } from 'pages/teaching_resources/interactive_classes/edit';
import { InteractiveClassShow } from 'pages/teaching_resources/interactive_classes/show';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'interactive_classes',
  label: 'Aulas interativas',
  list: InteractiveClassesList,
  create: InteractiveClassCreate,
  show: InteractiveClassShow,
  edit: InteractiveClassEdit,
  actions: ['list', 'show', 'create', 'edit', 'delete'],
  parentName: 'teaching_resources'
};

export default generateResources(resource);
